const discussions_en = require('./discussions.json')
export default discussions_en
